/**
 * Перемешивание массива (Fisher-Yates)
 * @param {string[]} letters - массив букв
 * @returns {string[]} - перемешанный массив
 */
export function shuffleLetters(letters) {
	const shuffled = [...letters];
	for (let i = shuffled.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
	}
	return shuffled;
}
